export enum UserFeatures {
  RSM_USAGE_STATISTICS_VIEW = 'Usage_Statistics_View',
  RSM_CALCULATION_HISTORY_VIEW = 'Calculation_History_View',
  PRICING_ACCESS = 'pricing_management_access',
  BILLING_ACCESS = 'billing_report_view',
  SCHEDULED_RETRIEVALS_VIEW = 'Scheduled_Retrievals_View',
  VIEW_AUTO_REVIEW_REPORTS = 'View_Auto_Review_Reports',
  ENORMOUS_FILE_UPLOAD = 'Enormous_File_Upload',
  AUTOREGRESSION_VIEW = 'Autoregression_View'
}